export default {"src":"/_next/static/media/circles2.16ee0e51.svg","height":333,"width":350,"blurWidth":0,"blurHeight":0};